import { render, staticRenderFns } from "./tipoTiendas.vue?vue&type=template&id=26cef494&scoped=true&"
import script from "./tipoTiendas.vue?vue&type=script&lang=js&"
export * from "./tipoTiendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cef494",
  null
  
)

export default component.exports